import { ClarityManager } from "../core/clarity.js"; 

document.addEventListener("DOMContentLoaded", () => {

    ClarityManager.initialize();

});


(window as any).updateHeader = async function () {

    
    const res = await fetch("/OpenHeader", {
        method: "GET",
        headers: {
            "Content-Type": "application/json"
        }, 
    }); 
    const result = await res.text();
    document.getElementById("header")!.innerHTML = result;


};